import { useState } from "react";
import { IconButton, Menu, MenuItem, Typography } from "@mui/material";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import styles from "../assests/scss/themes-vars.module.scss";

const NavbarNotification = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      {/* <IconButton onClick={handleClick} color="inherit" size="small" sx={{backgroundColor: styles.hIconbgColor, color: styles.hIconColor}}>
      <NotificationsNoneIcon/>
      </IconButton> */}
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleClose}>
          <div>
            <Typography variant="body2">No notification yet</Typography>
          </div>
        </MenuItem>
      </Menu>
    </>
  );
};

export default NavbarNotification;
